var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Helmet from 'react-helmet';
var CordataPageTitle = function CordataPageTitle(_ref) {
  var children = _ref.children,
    Tag = _ref.tag,
    icon = _ref.icon,
    action = _ref.action,
    props = _objectWithoutProperties(_ref, ['children', 'tag', 'icon', 'action']);
  return React.createElement(React.Fragment, null, React.createElement(Helmet, _extends({
    title: '' + children
  }, props)), React.createElement('div', {
    className: 'd-flex border-bottom mb-3'
  }, React.createElement(Tag, {
    className: 'mr-auto'
  }, icon && React.createElement(FontAwesomeIcon, {
    icon: icon,
    className: 'mr-2'
  }), children), action && React.createElement('div', {
    className: 'ml-auto'
  }, action)));
};
CordataPageTitle.propTypes = {
  children: PropTypes.node.isRequired,
  tag: PropTypes.string,
  icon: PropTypes.string,
  action: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string])
};
CordataPageTitle.defaultProps = {
  tag: 'h1',
  icon: undefined,
  action: undefined
};
export default CordataPageTitle;